import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Grid, Cell } from "react-md";
import { getTimeClockByPayPeriod, addTimeClock, deleteTimeClock, updateTimeClock } from "actions/account";
import { UserInformation, LoginActivity, EmployeeDetails, TeamMemberManagement } from "components/User";
import { MSpinner, MCard } from "components/Shared";
import { MANAGEMENT_CALENDAR_EDIT, AUTHENTICATION_EDIT } from 'typeConstants/rights';
import { userHasRight } from "selectors/rights";
import EmployeeCalendar from "components/Employee/EmployeeCalendar.tsx";
import { getEmployeeDetails } from "requests/employee";
import { getPayPeriodStartDate, getPayPeriodEndDate } from "components/EmployeeTimeLogs";
import { getTimeLogByDaySummary } from "actions/qualityAssurance";
import EmployeeTEAM from "components/Employee/EmployeeTEAM";
import EmployeeMappings from "components/EmployeeCustomerSurveyTypes/EmployeeMappings.tsx";
import { InternetUser, EmployeeDetailDto, InternetUserLoginStatisticsDto, EmployeeTimeClockActiveDto, PayPeriodViewModel, QATimeByDaySummary } from "interfaces/Mueller.Business.Models.ts";
import { auditQAQueueTypeMSelectOption, homeownersQaQueueTypeMSelectOption } from "typeConstants/employeeCustomerSurveyTypes";
import SummaryCardBusOps from "components/Shared/TimeLogs/SummaryCardBusOps";
import { ClockInOutCard, QualityAssuranceAuditResults  } from "components/Shared/TimeLogs";
import QAPerformanceLog from "components/QualityAssurance/QAPerformanceLog";
import { getPayPeriodList } from "actions/casetimelog";
import { HeaderDefinition } from "typeConstants/header/headerDefinitions";
import { getLoginStatistics, getUser } from "actions/user";

interface AgentQuickListProfileProps {
  verticalDisplay: boolean,
  loginStatistics: InternetUserLoginStatisticsDto,
  getLoginStatistics: (internetUserId: number) => InternetUserLoginStatisticsDto,
  isFetchingLoginStatistics: boolean,
  employeeId: number,
  internetUserId: number,
  internetUser: InternetUser,
  getUser: (internetUserId: number) => InternetUser,
  isFetchingInternetUser: boolean,
  canEditCalendarAsManager: boolean,
  canEditUsers: boolean,
  supervisorName: string,

  timeClockByPayPeriod: QATimeByDaySummary,
  activeClock: EmployeeTimeClockActiveDto,
  isFetchingTimeClockByPayPeriod: boolean,
  payPeriods: PayPeriodViewModel[],
  isFetchingPayPeriods: boolean,
  isFetchingTimeLogByDaySummary: boolean,
  timeLogByDaySummary: QATimeByDaySummary,
  //Dispatch
  addTimeClock: (internetUserId: number) => void,
  deleteTimeClock: (id: number) => void,
  updateTimeClock: (id: number, clockIn: number, clockOut: number) => void,
  getActiveClock: (timeZoneOffset: number) => void,
  getTimeClockByPayPeriod: (internetUserId: number, payPeriodId: number) => void,
  clockIn: (timeZoneOffset: number) => void,
  clockOut: (timeZoneOffset: number) => void,
  getCurrentPayPeriod: () => void,
  clearHeader: () => void,
  appendHeader: (headerDefintions: HeaderDefinition) => void,
  makeErrorToast: (text: string) => void,
  getTimeLogByDaySummary: (internetUserId: number, payPeriodId: number) => void,
}

const cellWidth = 12;

const AgentQuickListProfile = (props: AgentQuickListProfileProps) => {

  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [refreshSummaryCard, setRefreshSummaryCard] = useState(false);
  const onRefreshSummary = () => setRefreshSummaryCard(true);
  const [internetUserId, setInternetUserId] = useState(0);

  const mounted = useRef(true);

  useEffect(() => {
    if (refreshSummaryCard) setRefreshSummaryCard(false);
  }, [refreshSummaryCard]);

  useEffect(() => {
    props.getCurrentPayPeriod();
    return () => { 
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    let userId = props.internetUserId;
    setInternetUserId(userId);
    props.getLoginStatistics(userId);
    props.getUser(userId);
        
    getEmployeeDetails(userId, (response: EmployeeDetailDto) => setEmployeeDetails(response), mounted);
    
  }, [props.internetUserId]);

  let isLoading = props.isFetchingLoginStatistics ||
    props.isFetchingPayPeriods ||
    props.isFetchingInternetUser ||
    props.loginStatistics == null ||
    Object.keys(props.internetUser).length === 0 ||
    employeeDetails == null;

  if (isLoading) return (<MSpinner />);

  const currentPayPeriod = props.payPeriods[0];
  const payPeriodStartDate = getPayPeriodStartDate(currentPayPeriod.fromDate);
  const payPeriodEndDate = getPayPeriodEndDate(currentPayPeriod.toDate);

  return (
    <Grid className="md-grid-cards">
      <Cell size={cellWidth}>
        <SummaryCardBusOps
                    isBusOpsEmployeeTimeLogs={true}
                    data={props.timeLogByDaySummary}
                    isFetchingData={props.isFetchingTimeLogByDaySummary}
                    payPeriodId={currentPayPeriod.id}
                    getData={props.getTimeLogByDaySummary}
                    internetUserId={internetUserId}
                    refreshCard={refreshSummaryCard}
                  />
      </Cell>
      <Cell size={cellWidth}>
        <ClockInOutCard
                      displayClockInOutButton={false}
                      data={props.timeClockByPayPeriod}
                      isFetchingData={props.isFetchingTimeClockByPayPeriod}
                      payPeriod={currentPayPeriod}
                      getData={props.getTimeClockByPayPeriod}
                      isEditable={true}
                      internetUserId={internetUserId}
                      startDate={payPeriodStartDate}
                      endDate={payPeriodEndDate}
                      refreshSummaryCard={onRefreshSummary}
                    />
      </Cell>
      <Cell size={cellWidth}>
        <EmployeeTEAM internetUserId={internetUserId} />
      </Cell>
      <Cell size={cellWidth}>
        <QAPerformanceLog
            internetUserId={internetUserId}
            payPeriodId={currentPayPeriod.id}
            classNameOverride="qa-performance-log-control"
          />
      </Cell>
      <Cell size={cellWidth}>
        <QualityAssuranceAuditResults
            internetUserId={internetUserId}
          />
      </Cell>
      <Cell size={cellWidth}>
        <EmployeeDetails internetUserId={internetUserId} />
      </Cell>
      <Cell size={cellWidth}>
        <UserInformation
          userInformation={props.internetUser}
          internetUserId={internetUserId}
          canEditUser={props.canEditUsers}
        />
      </Cell>
      <Cell size={cellWidth}>
        <LoginActivity loginStatistics={props.loginStatistics} />
      </Cell>
      <Cell size={cellWidth}>
          <TeamMemberManagement internetUserId={internetUserId} userRights={props.internetUser.userRights} supervisorName={props.supervisorName} />
        </Cell>
      <Cell size={cellWidth}>
        <EmployeeMappings employeeId={props.employeeId} overrideQueueTypes={[homeownersQaQueueTypeMSelectOption ,auditQAQueueTypeMSelectOption]} />
      </Cell>
      <Cell size={cellWidth}>
        <MCard
          title="Employee Calendar"
          fields={[{
            key: "calendar",
            control: (
              <EmployeeCalendar
                employeeId={props.employeeId}
                readOnly={props.canEditCalendarAsManager ? false : true}
                allowManagementEdit={props.canEditCalendarAsManager}
              />)
          }]}
        />
      </Cell>
    </Grid>
  );
};

const mapStateToProps = state => {
  return {
    canEditCalendarAsManager: userHasRight(MANAGEMENT_CALENDAR_EDIT)(state),
    canEditUsers: userHasRight(AUTHENTICATION_EDIT)(state),
    activeClock: state.user.activeClock,
    timeLogs: state.caseTimeLog.timeLogs,
    isFetchingPayPeriod: state.caseTimeLog.isFetchingPayPeriods,
    payPeriods: state.caseTimeLog.payPeriods,
    timeClockByPayPeriod: state.user.timeClockByPayPeriod,
    isFetchingTimeClockByPayPeriod: state.user.isFetchingTimeClockByPayPeriod,
    timeLogByDaySummary: state.qualityAssurance.timeLogByDaySummary,
    isFetchingTimeLogByDaySummary: state.qualityAssurance.isFetchingTimeLogByDaySummary,
    isFetchingInternetUser: state.user.isFetchingInternetUser,
    isFetchingLoginStatistics: state.user.isFetchingLoginStatistics,
    loginStatistics: state.user.loginStatistics,
    internetUser: state.user.internetUser,
  };
};

const mapDispatchToProps = dispatch => ({
  addTimeClock(internetUserId, dto) {
    dispatch(addTimeClock(internetUserId, dto));
  },
  deleteTimeClock(id) {
    dispatch(deleteTimeClock(id));
  },
  updateTimeClock(id, clockIn, clockOut) {
    dispatch(updateTimeClock(id, clockIn, clockOut));
  },
  getCurrentPayPeriod() {
    dispatch(getPayPeriodList(1));
  },
  getUser(internetUserId: number){
    dispatch(getUser(internetUserId));
  },
  getLoginStatistics(internetUserId: number) {
    dispatch(getLoginStatistics(internetUserId));
  },
  getTimeLogByDaySummary(internetUserId: number, payPeriodId: number) {
    dispatch(getTimeLogByDaySummary(internetUserId, payPeriodId));
  },
  getTimeClockByPayPeriod(internetUserId: number, payPeriodId: number) {
    dispatch(getTimeClockByPayPeriod(internetUserId, payPeriodId));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgentQuickListProfile));
